/**
 * Module: jQuery $ Export
 *
 * Exports the shorthand $, which is just a reference to window.jQuery.
 * Fixes issues with "$ is not defined".
 *
 * Usage in modules/components:
 *
 *     import { $ } from '../common/utility/u-jquery-$';
 *
 * Usage in other utils:
 *
 *   `import { $ } from "./u-jquery-$";`
 *
 * @module utility/UJQuery$
 */


// Internal Vars
// ============================================================================

let $ = _getjQueryObj();


// ƒ
// ============================================================================

/**
 * Safe reference to the jQuery object. Refers to window.jQuery
 *
 * Exports from `utility/u-jQuery-$` as just $
 *
 * @returns {Object}  The jQuery ($) object
 */
function _getjQueryObj()
{
	let jQueryObj;

	// Is jQuery available as $()?
	if ( typeof( window.$ ) !== 'undefined' )
	{
		jQueryObj = window.$;
	}
	else
	{
		// Is jQuery available as jQuery()?
		if ( typeof( window.jQuery ) !== 'undefined' )
		{
			jQueryObj = window.jQuery;
		}
		else
		{
			console.error( '[UJQUERY] jQuery was not avaiable. Please check your enqueue dependancies' );
			jQueryObj = null;
		}
	}

	return jQueryObj;
}


// Exports
// ============================================================================

/**
 * Exported $
 *
 * @var {Object}
 */
export { $ };
